import React from "react";
import PropTypes from "prop-types";
import useDownload from "hooks/useDownload";
import DocumentActionButton from "components/helpers/DocumentActionButton";

export default function DocumentViewButton({
  documentId,
  antivirusStatus,
  antivirusThreats,
  children,
  className,
}) {
  const { handleView, isLoading } = useDownload(documentId);

  return (
    <DocumentActionButton
      onAction={handleView}
      isLoading={isLoading}
      antivirusStatus={antivirusStatus}
      antivirusThreats={antivirusThreats}
      className={className}
    >
      {children}
    </DocumentActionButton>
  );
}

DocumentViewButton.propTypes = {
  documentId: PropTypes.number.isRequired,
  antivirusStatus: PropTypes.string,
  antivirusThreats: PropTypes.array,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};
